import { render } from "./PerformanceMarketingCampaignTipBadge.vue?vue&type=template&id=0e081299"
import script from "./PerformanceMarketingCampaignTipBadge.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingCampaignTipBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__